/// <amd-module name="Run/Extensions/Components/MarkdownCard" />
import * as React from "react";

import { Attachment } from "Build/Client/Contracts/Build";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { issueRequest } from "VSS/Platform/Fetch";
import { Card } from "VSSUI/Card";

export interface IAttachment {
    name: string;
    content: string;
}

export interface IMarkdownSectionComponentProps {
    data: Attachment[];
}

/**
 * Inspect the provided urls for all protocols we want to prevent
 * The markdown-it defaults are to allow the data protocol if it is an image but
 * we don't want to allow embeded images that we'll have to scan for malicious content
 */
export function validateLinkProtocol(url: string): boolean {
    const str = url.trim().toLowerCase();
    return !/^(vbscript|javascript|file|data):/.test(str);
}

const s_markdownOptions = {
    breaks: true,
    html: true,
    validateLink: validateLinkProtocol
}

export function MarkdownCard(props: IMarkdownSectionComponentProps) {
    const [attachments, setAttachments] = React.useState([] as IAttachment[]);
    React.useEffect(() => {
        const promises: Promise<string>[] = [];
        const names: string[] = [];
        (props.data || []).forEach((attachment) => {
            attachment.name = attachment.name.replace(".md", "");
            const link = attachment._links["self"];
            if (link && link.href) {
                promises.push(issueRequest(link.href).then(async x => {
                    const buffer = await x.arrayBuffer();
                    let content = new Uint8Array(buffer);
                    if (content.length >= 3 && content[0] === 239 && content[1] === 187 && content[2] === 191) {
                        // skip BOM
                        content = content.slice(3, content.length - 1);
                    }
                    const utf8decoder = new TextDecoder();
                    return utf8decoder.decode(content);
                }, (reason) => {
                    console.error(reason);
                    return "";
                }));
                names.push(attachment.name);
            }
        });

        Promise.all(promises).then((contents) => {
            setAttachments(contents.map((value, index) => {
                return {
                    name: names[index],
                    content: value
                }
            }));
        })
    }, [props.data]);

    return <>
        {attachments.sort((firstCard, secondCard) => firstCard.name.localeCompare(secondCard.name, navigator.language)).map((x, index) => {
            return <Card
                key={x.name + index}
                className="build-ext-card">
                <div>
                    <div aria-level={2} className="body-xl" role="heading">
                        {x.name}
                    </div>
                    {
                        <LegacyComponent
                            modules={["DistributedTaskControls/Components/MarkdownRenderer"]}
                            wrappedType="dtMarkdownRenderer"
                            wrappedProps={{
                                cssClass: "content body-m",
                                markdownRendererOptions: s_markdownOptions,
                                markdown: x.content
                            }}
                        />
                    }
                </div>
            </Card>;
        })}
    </>
}
